import type { Author } from '~/interfaces/author';
import type { Publication } from '~/interfaces/publication';

interface ImageObjectSchema {
  '@type': 'ImageObject';
  contentUrl: string;
  thumbnailUrl?: string;
}

interface OrganizationSchema {
  '@type': 'Organization';
  name: string;
  url?: string;
}

export interface PersonSchema {
  '@type': 'Person';
  name: string;
  url?: string;
  description?: string;
  image?: ImageObjectSchema;
  sameAs?: string[];
  worksFor?: OrganizationSchema;
}

interface GetPersonSchemaOptions {
  url?: string;
  publication?: Pick<Publication, 'name' | 'url'>;
}

const getPersonSchema = (author: Author, { url, publication }: GetPersonSchemaOptions): PersonSchema => {
  const sameAs = [
    author.twitter_handle ? `https://x.com/${author.twitter_handle}` : null,
    author.facebook_url,
    author.instagram_url,
    author.linkedin_url,
    author.tiktok_url,
    author.youtube_url,
    author.discord_url,
    author.bluesky_url,
    author.threads_url,
  ].filter((value): value is string => Boolean(value));

  return {
    '@type': 'Person',
    name: author.name || '',
    url: url || undefined,
    description: author.bio || undefined,
    image: author.profile_picture?.url
      ? {
          '@type': 'ImageObject',
          contentUrl: author.profile_picture.url,
          thumbnailUrl: author.profile_picture.thumb?.url,
        }
      : undefined,
    sameAs: sameAs.length ? sameAs : undefined,
    worksFor: publication?.name
      ? {
          '@type': 'Organization',
          name: publication.name,
          url: publication.url || undefined,
        }
      : undefined,
  };
};

export default getPersonSchema;
